import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

// slice 02.1 · paso b — presentacional, extraído verbatim de `ComponentTaskHoy.jsx` (era un
// subcomponente a nivel de módulo). Muestra el tiempo transcurrido de un timer de "moment".
// Fase 5.18 (05-remediation.md, parte 2) -- `react-hooks/set-state-in-effect` (hint de React
// Compiler, no un bug de runtime) sube a `error` en todo `src/`. Este archivo hace setState
// síncrono dentro de un `useEffect` en un patrón de sincronización legítimo: resetea el tiempo mostrado cuando el timer deja de estar activo.
// No se reescribe a estado derivado (repetiría el fetch/haría el UI menos predecible en
// varios de estos casos) -- deshabilitado a nivel de archivo, con motivo, no en silencio.
/* eslint-disable react-hooks/set-state-in-effect */
export const LiveTimerTag = ({ startTime, active, savedDuration = 0, bgColor = '#ca8a04', textColor = '#fef08a' }) => {
    const [elapsed, setElapsed] = useState(0);

    useEffect(() => {
        if (!active || !startTime) {
            setElapsed(savedDuration);
            return;
        }

        const start = new Date(startTime).getTime();
        const update = () => {
            const now = new Date().getTime();
            setElapsed(savedDuration + Math.max(0, now - start));
        };

        update();
        const interval = setInterval(update, 60000); // Update every minute
        return () => clearInterval(interval);
    }, [startTime, active, savedDuration]);

    const minutes = Math.floor(elapsed / 60000);
    const hours = Math.floor(minutes / 60);
    const displayMins = minutes % 60;

    let text = '';
    if (hours > 0) {
        text = `${hours}h ${displayMins}m`;
    } else {
        text = `${displayMins}m`;
    }

    return (
        <span style={{
            backgroundColor: bgColor,
            color: textColor,
            padding: '2px 8px',
            borderRadius: '12px',
            fontSize: '10px',
            fontWeight: '600',
            marginLeft: 'auto',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px'
        }}>
            <Clock size={10} />
            {text}
        </span>
    );
};

export default LiveTimerTag;
